import { createSelector } from '@ngrx/store';
import { DataSchemaField, DataSchemaWithRelations, UiDataSelectorWithRelations, UiDataStore } from '@rappider/rappider-sdk';
import { getDataSchemasWithDetailsSelector } from 'libs/project/src/lib/states/selectors/get-data-schemas-with-details.selector';

export const getUIDataSelectors = createSelector(
  state => state['uiDataStore']?.data,
  state => state['uiDataSelector']?.data,
  getDataSchemasWithDetailsSelector,
  (uiDataStores: UiDataStore[], uiDataSelectors: UiDataSelectorWithRelations[], dataSchemas: DataSchemaWithRelations[]): UiDataSelectorWithRelations[] => {
    if (uiDataStores?.length && uiDataSelectors?.length && dataSchemas?.length) {
      return uiDataSelectors.map((uiDataSelector: UiDataSelectorWithRelations) => ({
        ...uiDataSelector,
        uiDataStoreFieldSelectors: uiDataSelector?.uiDataStoreFieldSelectors?.map(fieldSelector => {
          if (!fieldSelector || !fieldSelector.uiDataStoreId || !fieldSelector.uiDataStoreSchemaFieldIds?.length) {
            return {
              ...fieldSelector,
              uiDataStore: null,
              uiDataStoreSchemaFields: []
            };
          }

          const uiDataStore = uiDataStores.find(uiDataStore => uiDataStore.id === fieldSelector.uiDataStoreId);
          if (!uiDataStore || !uiDataStore.dataSchemaId) {
            return {
              ...fieldSelector,
              uiDataStore: uiDataStore || null,
              uiDataStoreSchemaFields: []
            };
          }

          const fields = [];
          for (let index = 0; index < fieldSelector.uiDataStoreSchemaFieldIds.length; index++) {
            const fieldId = fieldSelector.uiDataStoreSchemaFieldIds[index];
            let field;

            if (index === 0) {
              const schema = dataSchemas.find(dataSchema => dataSchema.id === uiDataStore.dataSchemaId);
              if (!schema || !schema.fields) {
                break;
              }
              field = schema.fields.find(field => field?.id === fieldId);
            } else {
              const previousField = fields[fields.length - 1];
              if (!previousField?.type?.fields) {
                break;
              }
              field = previousField.type.fields.find(field => field?.id === fieldId);
            }

            if (!field) {
              break;
            }

            fields.push(field);
          }

          return {
            ...fieldSelector,
            uiDataStore: uiDataStore,
            uiDataStoreSchemaFields: fields
          };
        }) ?? []
      }));
    }

    return [];
  }
);

// index 0 ise schema içerisinden field'ı bul
// index 0'dan büyük ise field array'i içerisinden bul
